// to-do setup dynamic webpack dynamic async importing
// to-do: deprecate when all v1 users have been migrated over
import {DieselRoute} from 'epic-diesel-common/src/hocs';
import './reducers/exports';
import './sagas/exports';

import {
    Overview,
    Settings,
    SignUp,
    NewTerms,
    CloseAccount,
    Payout,
    Dashboard,
    News,
    Article,
    FortniteGames,
    OAuthView,
    EulaView,
    Reactivate
} from './pages';

module.exports = {
    Overview: DieselRoute(Overview, {path: 'overview', isExactRoute: true}),
    Dashboard: DieselRoute(Dashboard, {path: 'dashboard', isExactRoute: true}),
    Settings: DieselRoute(Settings, {path: 'settings', isExactRoute: true}),
    SignUp: DieselRoute(SignUp, {path: 'signup', isExactRoute: true}),
    NewTerms: DieselRoute(NewTerms, {path: 'new-terms', isExactRoute: true}),
    CloseAccount: DieselRoute(CloseAccount, {path: 'close-account', isExactRoute: true}),
    Payout: DieselRoute(Payout, {path: 'payout', isExactRoute: true}),
    News: DieselRoute(News, {path: 'news', isExactRoute: true}),
    Article: DieselRoute(Article, {path: 'news/:slug'}),
    FortniteGames: DieselRoute(FortniteGames, {path: 'fortnite-games/:tab'}),
    OAuthPopup: DieselRoute(OAuthView, {path: 'auth_callback/oauth', isExactRoute: true}),
    Eula: DieselRoute(EulaView, {path: 'eula', isExactRoute: true}),
    Reactivate: DieselRoute(Reactivate, {path: 'reactivate', isExactRoute: true})
};
